<template>
  <div
    v-if="objPicked"
    class="row"
  >
    <h3 class="col-md-12">
      Ausgewählte Bestellnummer: {{ order.order_number }}
    </h3>
    <div
      v-if="property.id"
      class="row obj-selection"
    >
      <div class="col-sm-4">
        <p>Ausgewähltes Objekt</p>
      </div>
      <div class="col-sm-6">
        <p>
          {{ property.street }} {{ property.hsnr }}, {{ property.zip }} {{ property.city }}, {{ property.county }}
        </p>
      </div>
      <div class="col-sm-2">
        <button
          class="btn clr-btn btn-danger"
          @click="clearData"
        >
          CLEAR
        </button>
      </div>
    </div>
    <DocCards :documents="documents"></DocCards>
  </div>
</template>
<script>
import DocCards from '../components/DocCards.vue'

export default {
  components: {
    DocCards
  },
  props: {
    order: {
			type: Object,
			required: true
		}
  },
  data () {
    return {
      objPicked: false,
      documents: [],
      property: {},
      file: ''
    }
  },
  watch: {
    order: function (newVal) {
      if (newVal.id !== undefined) {
        this.getOrderInfo()
      } else {
        this.objPicked = false
      }
    }
  },
  methods: {
    getOrderInfo () {
      this.objPicked = false
      this.$axios.get(process.env.VUE_APP_BASE_URI + 'sadmin/orderDocs/' + this.order.id)
        .then((response) => {
          if (response.data.length > 0) {
            this.$axios.get(process.env.VUE_APP_BASE_URI + 'sadmin/docProp/' + response.data[0].property_id)
              .then((res) => {
                this.documents = response.data
                this.property = res.data
                this.objPicked = true
              })
          }
        })
    },
    clearData () {
      localStorage.removeItem('order_id')
      this.$router.go()
    }
  }
}
</script>
<style>
</style>
